<template>
  <div class="col-xs-6 col-xs-offset-3 col-md-2 col-md-offset-5  form-group">
    <div :class="['share_btn', btnColor]">
      <a @click="update">下一步</a>
    </div>
  </div>
</template>

<script>
export default {
  name: "go_next_button",
  props: {
    page_no: Number,
    component_name: String,
    model: Object
  },
  data () {
    return {
      moduleName: '',
    }
  },
  methods: {
    update() {
      if (this.component_name === 'MultipleInput') {
        this.handleMultipleInput()
        return
      }

      if (
          store.get(`${this.moduleName}@postData.${this.page_no}`)
          &&
          !store.get(`${this.moduleName}/isEmpty`)
      ) {
        store.set(`${this.moduleName}/isEmpty`, false)
        this.$emit('update')
      } else {
        store.set(`${this.moduleName}/isEmpty`, true)
      }
    },
    handleMultipleInput() {
      let multipleInput = store.get(`${this.moduleName}@postData.${this.page_no}`)
      let multipleInputLength =multipleInput.filter(item => !(item || item === 0)).length
      if (multipleInputLength !== 0 || multipleInput.length === 0) store.set(`${this.moduleName}/isEmpty`, true)
      else {
        store.set(`${this.moduleName}/isEmpty`, false)
        this.$emit('update')
      }
    }
  },
  computed: {
    btnColor() {
      switch (this.moduleName) {
        case "buyHouse":
          return 'share_btn_peachDefault';
        case "educationFund":
          return 'share_btn_orangeDefault'
        default:
            return "share_btn_orangeDefault"
      }
    }
  },
  created() {
    this.moduleName = store.get('moduleName')
  }
}
</script>